































































































































































import Vue from 'vue';
import TheCalender from '@/components/TheCalender.vue'; // @ is an alias to /src
import ModifyEventDetails from '@/components/ModifyEventDetails.vue'; // @ is an alias to /src
import CreateEvent from '@/components/CreateEvent.vue'; // @ is an alias to /src
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import router from '@/router/index'; 


export default Vue.extend({
    name: 'Home',
    components: {
        TheCalender,
        VueCal,
        ModifyEventDetails,
        CreateEvent,
    },
    data() {
        return {
            fileUpload: null,
            userAccess_CreateEvent: false,
            viewModeSelectedOption: 'Calendar',
            viewModeOptions: [
                {text: "Calendar", value: "Calendar"},
                {text: "Table (All Event)", value: "Table"},
            ],
            allEventKeywordFilter: null,
            allEventPaginationNumItemShow: 10,
            allEventCurrPagination: 1,
            allEventTableFields:[
                {key:"eventRefId",label:"Ref ID", sortable: false,thStyle: { width: "10%"  } },
                {key:"title",label:"Event Name", sortable: false, thStyle: { width: "50%"  } },
                //{key:"eventDate",label:"Event Date"},
                //{key:"startTime",label:"Start Time"},
                //{key:"endTime",label:"End Time"},
                {key:"createdBy",label:"CreatedBy"},
                {key:"eventStartTimestamp",label:"Start", sortable: false, thStyle: { width: "20%"  } },
                {key:"eventEndTimestamp",label:"End", sortable: false, thStyle: { width: "20%"  } }
            ],
            modifyEventDetailIdToshow:2,
            maxWidthDialog:900,
            isShowCreateEvent:false,
            isShowDateSelectBtn:false,
            isShowCalendar: false,
            isShowEventDetail: false,
            rangeSelectMode:'week',
            selectedDate:new Date(),
            allEventItems:[
                {
                    eventId:0,
                    createdBy:"",
                    eventRefId:"",
                    eventDate: '2021-11-20',
                    eventStartTimestamp: '',
                    eventEndTimestamp: '',
                    startTime: '2021-11-20 18:00:00',
                    endTime: '2021-11-20 18:00:00',
                    title: '<b>Fun with Java</b>',
                    content: '',
                    class: 'leisure'
                },
            ],
            items:  [
                {
                    eventId:0,
                    start: '2021-11-20 14:00:00',
                    end: '2021-11-20 18:00:00',
                    title: '<b>Fun with Java</b>',
                    content: '',
                    class: 'leisure'
                },
            ],
            eventTypeOptionList:[{eventTypeId:-1,eventtype:""}],
            orgOptionList:[{eventOrganizerId:-1,eventorg:""}],
            monthNames:[
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'June',
                'July',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            events: [
                {
                    start: '2021-11-20 14:00:00',
                    end: '2021-11-20 18:00:00',
                    title: '<b>Fun with Java</b>',
                    content: '<b>Facilated By:</b> Ms Jeyashree Rajkumar<br> <b>Hosted By:</b> WOU - DiGiT<br> <b>Event Type:</b>WOU Upskill Series',
                    class: 'leisure'
                },
                {
                    start: '2021-11-22 10:00',
                    end: '2021-11-22 15:00',
                    title: 'Golf with John',
                    content: 'Do I need to tell how many holes?',
                    contentFull: 'Okay.<br>It will be a 18 hole golf course.', // Custom attribute.
                    class: 'sport'
                }
            ]
        }
    },
    computed: {
        filterDate(): string{
            // return `${temp_split[0]} ${temp_split[1]}`;
            return this.$store.state.filteredDateSelection.selFilterStart;
        },
        allEventNumPagination(): number{
            return this.allEventItems.length;
        }
    },
    mounted(){
        //this.$store.dispatch("updateEventList");
        var year = this.selectedDate.getFullYear();
        var month = this.selectedDate.getMonth();
        var day = this.selectedDate.getUTCDate();
        var dateStr = `${year}-${month}-${day}`;

        this.$store.commit('update_filteredDateSelection',{start:`${dateStr}T00:00:00`,end:`${dateStr}T23:59:59`});
        this.items = [];
        this.checkUsrAuthorizeAction();
        this.allEventItems = [];
        this.updateOrganizerList();
        this.updateEventTypeList();
        this.eventListReader();

        this.isShowCreateEvent=true;
        this.isShowDateSelectBtn=true;

        //console.log(";lllll")
        //console.log(this.$store.state.filteredDateSelection.selFilterStart) as any;
        //(this.$refs.vuecal as any).switchView(this.rangeSelectMode, new Date(this.$store.state.filteredDateSelection.selFilterStart));    
    },
    watch:{
        filterDate: function() {
            var temp = this.$store.state.filteredDateSelection.selFilterStart;
            this.selectedDate = new Date(this.$store.state.filteredDateSelection.selFilterStart);
            //if(this.$refs.vuecal){
            //    if(this.$store.state.filteredDateSelection.selFilterStart == ""){
            //        (this.$refs.vuecal as any).switchView(this.rangeSelectMode, new Date(this.selectedDate));    
            //    }else{
            //        (this.$refs.vuecal as any).switchView(this.rangeSelectMode, new Date(this.$store.state.filteredDateSelection.selFilterStart));    
            //    }
            //}

            //console.log("iSome changes happen");
            //this.eventListReader();
        },
    },
    methods:{

        checkUsrAuthorizeAction: function(){
            fetch(`${this.$server_address}/GetAuthorizeAction`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json; charset=utf-8',
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({actionName:"createNewEvent",eventId:-1})
            }).then(
                function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    this.userAccess_CreateEvent = data.isActionAuthorize;
                } 
            )
            .catch(
                (err)=>{
                    console.error(err)
                }
            )
        },
        handler_modal_createEvent_close: function(){
            // this is called after the modal is closed
            //console.log("closed");
            this.eventListReader();
        },
        handler_createEvent_close_dialog: function(){
            // this is custom event to call parent to close modal
            this.$modal.hide('modalCreateEventName');          
        },
        handler_createEvent_scrollToTop_dialog:function(){
            (this.$refs.modalCreateEvent as any).scrollTop = 0;
        },
        handler_floatBtn_createEvent_click:function(){
            this.$modal.show('modalCreateEventName');   
        },
        handler_scrollToTop_dialog: function(){
            (this.$refs.modalModifyEventDetail as any).scrollTop = 0;
        },
        handler_close_dialog:function(){
            // this is custom event to call parent to close modal
            this.$modal.hide('modalModifyEventDetailName')
        },
        handler_modal_close:function(){
            // this is called after the modal is closed
            //console.log("closed");
            this.eventListReader();
        },
        handler_floatBtn_click: function(){
            this.isShowCalendar = !this.isShowCalendar;
            this.isShowDateSelectBtn = !this.isShowCalendar;
        },
        handler_floatBtn_mouseleave: function(){
            this.isShowCalendar = false;
            this.isShowDateSelectBtn = true;
        },
        handler_vuecal_view_change: function(event_string:any,event:any){
            //console.log(event)
            var temp = this.$store.state.filteredDateSelection.selFilterStart;
        //    var temp_split = temp.split("T");

            //if(this.$refs.vuecal){
            //    (this.$refs.vuecal as any).switchView(this.rangeSelectMode, new Date(this.$store.state.filteredDateSelection.selFilterStart));
            //}
            this.rangeSelectMode = event.view;
        },
        handler_vuecal_click_event: function(event:any, e:any){
            //alert(event.eventId);
            //this.$store.commit('update_filteredDateSelection',{start:``});
            //router.push({ name: 'EventDetails', params: { id: event.eventId.toString()} });
            //(this.$refs['my-modal'] as any).show() 
            //this.isShowEventDetail = true;
            this.$modal.show('modalModifyEventDetailName');
            this.modifyEventDetailIdToshow = event.eventId.toString();
        },
        handler_allEventTable_click_event: function(id:number){
            //alert(event.eventId);
            //this.$store.commit('update_filteredDateSelection',{start:``});
            //router.push({ name: 'EventDetails', params: { id: event.eventId.toString()} });
            //(this.$refs['my-modal'] as any).show() 
            //this.isShowEventDetail = true;
            this.$modal.show('modalModifyEventDetailName');
            this.modifyEventDetailIdToshow = id;
        },

        updateEventTypeList: function(){  
            fetch(`${this.$server_address}/GetAllEventTypes`, {
                method: 'GET',
                credentials: 'include',
                //body:JSON.stringify({title:"a new todo"})
            }).then(
                function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    this.eventTypeOptionList = data;
                } 
            )
            .catch(
                (err)=>{
                    console.error(err)
                }
            )
        },
        updateOrganizerList: function(){
            fetch(`${this.$server_address}/GetAllEventOrganizers`, {
                method: 'GET',
                credentials: 'include',
                //body:JSON.stringify({title:"a new todo"})
            }).then(
                function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    this.orgOptionList = data;
                } 
            )
            .catch((err)=>console.error(err))
        },
        eventListReader: function(){
            fetch(`${this.$server_address}/GetAllEventDetails`,
            {
                method: "GET",
                credentials: 'include',
            })
            .then(
                function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    this.items = [];
                    this.allEventItems = [];

                    for(var x = 0; x < data.length ; x++){
                        if(!data[x].eventId){
                            continue;
                        }
                        
                        if(!data[x].eventName){
                            continue;
                        }
                        
                        //if(!data[x].createdBy){
                        //    continue;
                        //}

                        //if(!data[x].latestUpdateTimestamp){
                        //    continue;
                        //}

                        if(!data[x].namefacilitatorspresentersspeakers){
                            continue;
                        }

                        if(!data[x].eventOrgId){
                            continue;
                        }

                        if(!data[x].eventTypeId){
                            continue;
                        }           

                        if(!data[x].eventStartTime){
                            continue;
                        }

                        if(!data[x].eventEndTime){
                            continue;
                        }

                        let temp_eventOrg = "";
                        if(this.orgOptionList.length > 0){
                            for(var y = 0 ; y < this.orgOptionList.length ; y++){
                                if(this.orgOptionList[y].eventOrganizerId == data[x].eventOrgId){
                                    temp_eventOrg = this.orgOptionList[y].eventorg;
                                }
                            } 
                        }

                        let temp_eventType = "";
                        if(this.eventTypeOptionList.length > 0){
                            for(var z = 0 ; z < this.eventTypeOptionList.length ; z++){
                                if(this.eventTypeOptionList[z].eventTypeId == data[x].eventTypeId){
                                    temp_eventType = this.eventTypeOptionList[z].eventtype;
                                }
                            } 
                        }

    
                        var filterDateStartDisplay = new Date(data[x].eventStartTime);
                        var monthName:string = this.monthNames[filterDateStartDisplay.getMonth()];
                        var temp:string = data[x].eventStartTime;
                        var temp_split = temp.split("T");
                        var start_calendar_string = `${temp_split[0]} ${temp_split[1]}`;
                        var startTimeTemp = temp_split[1].split(":");
                        var startTimeDisp = `${startTimeTemp[0]}:${startTimeTemp[1]}`;
                        var filterDateStartDisplayTemp = `${filterDateStartDisplay.getDate()} ${monthName} ${filterDateStartDisplay.getFullYear()}  ${temp_split[1]}`;

                        var filterDateEndDisplay = new Date(data[x].eventEndTime);
                        monthName = this.monthNames[filterDateEndDisplay.getMonth()];
                        temp = data[x].eventEndTime;
                        temp_split = temp.split("T");
                        var end_calendar_string = `${temp_split[0]} ${temp_split[1]}`;
                        var endTimeTemp = temp_split[1].split(":");
                        var endTimeDisp = `${endTimeTemp[0]}:${endTimeTemp[1]}`;
                        var filterDateEndDisplayTemp = `${filterDateEndDisplay.getDate()} ${monthName} ${filterDateEndDisplay.getFullYear()}  ${temp_split[1]}`;

                        //console.log(start_calendar_string)
                        //console.log(end_calendar_string)
                        //console.log(data[x].eventName)
                        
                        //console.log("temp_eventType")
                        
                        //console.log(data[x].eventName)
                        //console.log(data[x].eventTypeId)

                        var eventClassStylingColorTag = 'normal'
                        if(data[x].eventTypeId == 1){
                            eventClassStylingColorTag = 'eventTagColorStyle_1'
                        }
                        else if(data[x].eventTypeId == 2){
                            
                            eventClassStylingColorTag = 'eventTagColorStyle_2'
                        }
                        else if(data[x].eventTypeId == 3){
                            eventClassStylingColorTag = 'eventTagColorStyle_3'
                        }
                        else if(data[x].eventTypeId == 4){
                            eventClassStylingColorTag = 'eventTagColorStyle_4'
                        }
                        else if(data[x].eventTypeId == 5){
                            eventClassStylingColorTag = 'eventTagColorStyle_5'
                        }
                        else if(data[x].eventTypeId == 6){
                            eventClassStylingColorTag = 'eventTagColorStyle_6'
                        }
                        else if(data[x].eventTypeId == 7){
                            eventClassStylingColorTag = 'eventTagColorStyle_7'
                        }
                        else if(data[x].eventTypeId == 8){
                            eventClassStylingColorTag = 'eventTagColorStyle_8'
                        }
                        else if(data[x].eventTypeId == 9){
                            eventClassStylingColorTag = 'eventTagColorStyle_9'
                        }
                        else if(data[x].eventTypeId == 10){
                            eventClassStylingColorTag = 'eventTagColorStyle_10'
                        }
                        else if(data[x].eventTypeId == 11){
                            eventClassStylingColorTag = 'eventTagColorStyle_11'
                        }
                        else if(data[x].eventTypeId == 12){
                            eventClassStylingColorTag = 'eventTagColorStyle_12'
                        }
                        else if(data[x].eventTypeId == 13){
                            eventClassStylingColorTag = 'eventTagColorStyle_13'
                        }
						else if(data[x].eventTypeId == 1022 || data[x].eventTypeId == 1023 || data[x].eventTypeId == 1024){
							eventClassStylingColorTag = 'eventTagColorStyle_WOUHub'
						}
						else if(data[x].eventTypeId == 1025 || data[x].eventTypeId == 1026 || data[x].eventTypeId == 1027){
							eventClassStylingColorTag = 'eventTagColorStyle_RCEvent'
						}
                        else {
                            eventClassStylingColorTag = 'normal'
                        }

                        this.items.push({
                            eventId:data[x].eventId,
                            start: start_calendar_string,
                            end: end_calendar_string,
                            title: `(${startTimeDisp}-${endTimeDisp}) <br><b>${data[x].eventName}</b>` as string,
                            content: ``,
                            //content: `<b>Facilated By:</b> ${data[x].namefacilitatorspresentersspeakers}<br> <b>Hosted By:</b> ${temp_eventOrg}<br> <b>Event Type:</b> ${temp_eventType}`,
                            class:eventClassStylingColorTag,
                        });

                        
                        this.allEventItems.push({
                            eventId:data[x].eventId,
                            createdBy:data[x].createdBy,
                            eventRefId: data[x].eventRefNum,
                            eventDate: start_calendar_string.split(" ")[0],
                            eventStartTimestamp: start_calendar_string,
                            eventEndTimestamp: end_calendar_string,
                            startTime: start_calendar_string.split(" ")[1],
                            endTime: end_calendar_string.split(" ")[1],
                            title: `${data[x].eventName}` as string,
                            content: ``,
                            //content: `<b>Facilated By:</b> ${data[x].namefacilitatorspresentersspeakers}<br> <b>Hosted By:</b> ${temp_eventOrg}<br> <b>Event Type:</b> ${temp_eventType}`,
                            class:'normal',
                        });

            
                    
                    }
                    //eventorgid
                    //eventtypeid
                    //namefacilitatorspresentersspeakers
                    /* 
                        createdBy: "UserA"
                        createdTimestamp: "2021-11-21T10:35:46.241644"
                        eventdate: null
                        eventendtime: "2021-11-01T14:12:00"
                        eventid: "T1"
                        eventname: "Reduce Study Duration and Cost Through APEL"
                        eventorgid: 3
                        eventstarttime: "2021-11-01T09:02:00"
                        eventtypeid: 2
                        id: 1
                        latestUpdateTimestamp: "2021-11-21T10:35:46.241644"
                        numberparticipants: 32
                        seldetailsid: 1
                    */

                    //this.event_remarks = data[0].remarks
                } 
            )

            //this.items = this.$store.state.event_list;
        },
    }
});
